module.exports = __webpack_public_path__ + "static/media/man_barrels_getty_desktop.078c39ec.jpg";